

















































import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import AsiListTable from "@/components/common/AsiListTable.vue";
import AsiTextFieldSimple from "@/components/common/AsiTextFieldSimple";
import AsiListTableHeader from "@/components/common/AsiListTableHeader";
import {enumTextFromValue, enumToSelectItems} from "@/helpers/functions_asi";
import {Permissions, ReportState} from "@/helpers/constants";
import AsiSelect from "@/components/common/AsiSelect";
import AsiListTableOptions from "@/components/common/AsiListTableOptions";
import IAsiListTableImplementation from "@/components/common/IAsiListTableImplementation";
import PaginatedResponse from "@/models/PaginatedResponse";
import AsiListTableLayout from "@/components/common/AsiListTableLayout.vue";
import AsiSelectSimple from "@/components/common/AsiSelectSimple";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import AsiAvatar from "@/components/common/AsiAvatar.vue";
import ReportListEntry from "../../models/report/ReportListEntry";
import ReportListFilter from "../../models/report/ReportListFilter";
import {Icon} from "@/helpers/icons";
import UserSimple from "@/models/user/UserSimple";
import CompanySimple from "@/models/company/CompanySimple";
import OrderSimple from "@/models/order/OrderSimple";
import BillSimple from "@/models/bill/BillSimple";
import AsiDatePicker from "@/components/common/AsiDatePicker.vue";

@Component({
	components: {
		AsiDatePicker,
		AsiAvatar,
		AsiContentContainer,
		AsiSelectSimple,
		AsiListTableLayout, AsiSelect, AsiTextFieldSimple, AsiListTable
	}
})
export default class ReportList extends AsiListTable<ReportListEntry, ReportListFilter> implements IAsiListTableImplementation<ReportListEntry, ReportListFilter> {

	@Prop({type: Object, default: null})
	public orderCompany!: CompanySimple | null;

	@Prop({type: Object, default: null})
	public driverCompany!: CompanySimple | null;

	@Prop({type: Object, default: null})
	public order!: OrderSimple | null;

	@Prop({type: Object, default: null})
	public user!: UserSimple | null;

	@Prop({type: Object, default: null})
	public bill!: BillSimple | null;

	@Prop({type: Boolean, default: false})
	public billWithUnassignedReports!: boolean;

	@Prop({type: Object, default: null})
	public reportFilterModel!: ReportListFilter | null;

	@Prop({type: Boolean, default: false})
	public hideToolbar!: boolean;

	@Prop({type: Boolean, default: false})
	public showSelect!: boolean;

	@Prop({default: () => []})
	public value!: ReportListEntry[];

	protected reportStateOptions = enumToSelectItems(ReportState, true);
	private valueInternal: ReportListEntry[] = [];
	private icons = Icon;

	public constructor() {
		super();
		this.filterModel = this.createFilterModel();

		if (this.isCustomer) {
			this.reportStateOptions = this.reportStateOptions.filter(rso => rso.value !== ReportState.created);
		}
	}

	private get dateRange(): string[] | null {
		if (this.filterModel === null) return null;
		const ret = [];
		if (this.filterModel.dateFrom !== null) ret.push(this.filterModel.dateFrom);
		if (this.filterModel.dateTo !== null) ret.push(this.filterModel.dateTo);
		return ret;
	}

	private set dateRange(value: string[] | null) {
		if (this.filterModel === null) return;
		this.filterModel.dateFrom = value === null ? null : (value[0] ?? null);
		this.filterModel.dateTo = value === null ? null : (value[1] ?? null);
	}

	private get isInternal(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightInternal);
	}

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	private get isCustomer(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCustomer);
	}

	@Emit('input')
	public input(): ReportListEntry[] {
		return this.valueInternal;
	}

	@Emit('change')
	public change(): ReportListEntry[] {
		return this.valueInternal;
	}

	public mounted(): void {
		this.updateValueInternal();
		this.tableOptions.sortBy = ['date'];
		this.tableOptions.sortDesc = [true];
		this.reload();
	}

	public createFilterModel(): ReportListFilter {
		const filterModel = this.reportFilterModel ?? new ReportListFilter();
		if (this.orderCompany !== null) filterModel.orderCompanyId = this.orderCompany.id;
		if (this.driverCompany !== null) filterModel.driverCompanyId = this.driverCompany.id;
		if (this.order !== null) filterModel.orderId = this.order.id;
		if (this.user !== null) filterModel.userId = this.user.id;
		if (this.bill !== null) filterModel.billId = this.bill.id;

		if (this.isCustomer) {
			filterModel.states = [ReportState.checked, ReportState.billed, ReportState.locked];
		}

		return filterModel;
	}

	public createHeaders(): AsiListTableHeader[] {
		const ret = [];
		if (!this.user) {
			ret.push(new AsiListTableHeader('', 'avatar', false, false, 'center', '4rem'));
			ret.push(new AsiListTableHeader(this.$t('uiTerms.reportUser').toString(), 'fullName', true, true, 'start', this.orderCompany === null || this.order === null ? null : '20%'));
		}
		ret.push(new AsiListTableHeader(this.$t('report.date').toString(), 'date', true, true, 'start', '10rem'));
		if (!this.orderCompany && !this.order) {
			ret.push(new AsiListTableHeader(this.$t('company.singular').toString(), 'company.name', true, true, 'start', this.user ? null : '20%'));
		}
		if (!this.order) {
			ret.push(new AsiListTableHeader(this.$t('order.singular').toString(), 'order.name', true, true, 'start', '20%'));
		}
		ret.push(new AsiListTableHeader(this.$t('report.state').toString(), 'state', true, true, 'start', '15%'));

		return ret;
	}

	public fetchData(filterModel: ReportListFilter | null, tableOptions: AsiListTableOptions | null): Promise<PaginatedResponse<ReportListEntry>> {
		let numModels = 0;
		if (this.orderCompany !== null) numModels++;
		if (this.driverCompany !== null) numModels++;
		if (this.order !== null) numModels++;
		if (this.user !== null) numModels++;
		if (this.bill !== null) numModels++;

		if (numModels !== 1) {
			return this.$reportService.reports(filterModel, tableOptions);
		} else if (this.orderCompany !== null) {
			return this.$companyService.reports(this.orderCompany.id, filterModel, tableOptions);
		} else if (this.driverCompany !== null) {
			return this.$companyService.reports(this.driverCompany.id, filterModel, tableOptions);
		} else if (this.order !== null) {
			return this.$orderService.reports(this.order.id, filterModel, tableOptions);
		} else if (this.user !== null) {
			return this.$userService.reports(this.user.id, filterModel, tableOptions);
		} else if (this.bill !== null) {
			if (!this.billWithUnassignedReports) {
				return this.$billService.reports(this.bill.id, filterModel, tableOptions);
			} else {
				return this.$billService.reportsWithPotentialReports(this.bill.id, filterModel, tableOptions);
			}
		} else {
			throw Error('invalid configuration of report list');
		}
	}

	public filterTextChanged(filterText: string): void {
		if (this.filterModel === null) return;
		this.filterModel.fulltext = filterText;
	}

	public openModelDetailPage(model: ReportListEntry): void {
		this.$router.push({name: 'Report', params: {id: model.id}});
	}

	public reload(goToFirstPage: boolean = false): void {
		this.reloadInternal(this, goToFirstPage);
	}

	public userFullName(user: UserSimple | null): string | null {
		return UserSimple.fullName(user);
	}

	public reportStateLabel(model: ReportListEntry): string | null {
		return enumTextFromValue(ReportState, model.state, true);
	}

	public isStateCreated(report: ReportListEntry): boolean {
		return report.state === ReportState.created;
	}

	protected avatarUrl(userSimple: UserSimple): string | null {
		return UserSimple.avatarUrlMedium(userSimple);
	}

	@Watch('value', {deep: true})
	private onValueChanged(): void {
		this.updateValueInternal();
	}

	@Watch('billWithUnassignedReports')
	private onBillWithUnassignedReportsChanged(): void {
		this.reload();
	}

	private updateValueInternal(): void {
		this.valueInternal = this.value;
	}

	@Watch('tableOptions', {deep: true})
	private onTableOptionsChanged(): void {
		this.reload();
	}

	@Watch('filterModel', {deep: true})
	private onFilterModelChanged(): void {
		this.reload(true);
	}

}
